module.exports = __webpack_public_path__ + "src/img/bangong_on.24241afa.svg";